import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";
import { getRequest, patchRequest } from "../../api/ApiService";
import { logError } from "../../services/utils";
import EventEmitter from "../../services/event-emitter";
import HelpIconButtonWithTooltipAndTypeformModal from "../typeform/HelpIconButtonWithTooltipAndTypeformModal";
import TypeformContent from "../typeform/TypeformContent";
import { view } from "@risingstack/react-easy-state";
import Auth from '../../routes/Auth';

const AR_TERMS_URL = `${process.env.REACT_APP_API_URL}team/receivable_terms/`;

class AccountReceivableTerms extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
      value: "0",
      isLoading: false,
      show: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  show = () => {
    this.setState({
      show: true
    });
  };

  close = () => {
    this.setState({
      show: false
    });
  };

  componentDidMount() {
    this.eventemitter.on("pm-decisions-open-modal4", this.show);

    let appURL = AR_TERMS_URL;
    const temporaryUser = Auth.getTemporaryUser();
    if (temporaryUser) {
      appURL = `${appURL}?team_id=${temporaryUser.team_id}`;
    }

    getRequest(appURL)
      .then(res => {
        const { rounds, roundNumber } = this.props;
        const round = rounds.find(i => i.number === roundNumber);
        const data = round
          ? res.body.filter(i => i.round === round.id)
          : res.body;
        const { id, days } = data[0];
        const value = days + "";

        this.setState({
          id,
          value
        });
      })
      .catch(err => {
        logError(err, "AccountReceivableTerms", "componentDidMount");
      });
  }

  componentWillUnmount() {
    this.eventemitter.off("pm-decisions-open-modal4", this.show);
  }

  onSubmit = () => {
    const { value, id } = this.state;

    this.setState({
      isLoading: true
    });

    patchRequest(`${AR_TERMS_URL}${id}/`)
      .send({
        days: value
      })
      .then(res => {
        this.props.showSuccessMessage('New credit terms have been successfully set');
        this.props.getSubmissionData();
        this.setState({
          isLoading: false,
          show: false
        });
      })
      .catch(err => {
        logError(err, "AccountReceivableTerms", "onSubmit");
      });
  };

  onChange = event => {
    const value = event.target.value + "";

    this.setState({
      value
    });
  };

  render() {
    const { show, value, isLoading } = this.state;

    return (
      <Modal show={show} onHide={this.close} id="AccountReceivableTermsModal">
        <Modal.Header>
          <h4 className="modal-title title-light-blue">
            Accounts Receivable
            <HelpIconButtonWithTooltipAndTypeformModal
              iconSize="xs"
              {...TypeformContent.ACCOUNT_RECEIVABLE}
            />
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive mt-20">
            <table className="table">
              <tbody>
                <tr className="border-none pm-decisions-select">
                  <td className="text-center">
                    Customer
                    <br />
                    Credit Terms
                    <br />
                    (in # of days)
                  </td>
                  <td className="text-center">
                    <select
                      onChange={this.onChange}
                      value={value}
                      disabled={isLoading}
                    >
                      <option value="0">0</option>
                      <option value="30">30</option>
                      <option value="60">60</option>
                      <option value="90">90</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-cancel" onClick={this.close}>
            Cancel
          </Button>
          <Button
            className="btn btn-save"
            disabled={isLoading}
            onClick={this.onSubmit}
          >
            {isLoading === true ? "Loading..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default view(AccountReceivableTerms);



// WEBPACK FOOTER //
// ./src/components/accounts/AccountReceivableTerms.js